import analytics from '../../components/analytics/Analytics';
import segmentAnalytics from '../../components/analytics/SegmentAnalytics';
import ScoreStrip from '../../components/scorestrip/scorestrip';
import CountdownClock from '../../components/sidebar/CountdownClock';
import TopVideos from '../../components/sidebar/TopVideos.js';
import FsBeacon from '../../components/fs-beacon/FsBeacon';
import SitewideModal from '../../../react-app-src/sitewideModal/components/SitewideModal';

class BaseJS {
    constructor() {
        this.initFsBeacon();
        this.initSitewideModal();
        this.initScoreStrip();
        this.initCountDownClock();
        this.initAnalytics();
        this.initTopVideo();
    }

    initFsBeacon()  {
        window.FsBeacon = new FsBeacon();
    }

    initSitewideModal() {
        let modalHandler = new SitewideModal();
        modalHandler.render();
    }

    initTopVideo() {
        new TopVideos();
    }

    initScoreStrip() {
        //temporary for external access
        //being used in big-board.js and marquee gallery

        if (document.getElementById('ScoresLink')) {
            let scorestrip = new ScoreStrip();

            if (document.querySelector('wis-scorestrip')) {
                scorestrip.init();
            } // FSCOM-13229: preemptively load the scorestrip on iOS mobile devices only when scorestrip is disable on page
            else if (scorestrip.viewport.isMobile && scorestrip.viewport.isIOS) {
                scorestrip.createScoreStrip( scorestrip.scoreStripButton.getAttribute('data-sport'), scorestrip.scoreStripButton.getAttribute('data-group-id') );
            }
        }
    }

    initCountDownClock() {
        // Set up sidebar components
        var countdownClocks = document.querySelectorAll('.sidebar-component-countdown-clock');
        if (countdownClocks.length > 0) {
            for (var i = 0, clockLen = countdownClocks.length; i < clockLen; i++) {
                new CountdownClock(countdownClocks[i]);
            }
        }
    }

    initAnalytics() {
        analytics.sendPageView();
    }
}

new BaseJS();

//object can be reused when importing this script
export default {
    'analytics': analytics,
    'segmentAnalytics': segmentAnalytics
}





// WEBPACK FOOTER //
// ./assets/layouts/base/base.js